import React, { Component } from "react";
import { Button, Form, Icon, Grid } from "tabler-react";
import Select from "react-select";
/**
 * Date tools
 */
import { timeToDateFill } from "../../../../herramientas/DateFormat";
import DateTimePicker from "react-datetime-picker";
let campo = "";

class EntregasNavierasForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idEntrega: 0,
      idDestino: { value: 1, label: "DESTINO SIN CATALOGO", indice: 0 },
      destino: "",
      direccion: "",
      estatus: 0,
      latitud: 0,
      longitud: 0,
      cita: "",
      inicioRuta: "",
      fechaArribo: "",
      fechaSalida: "",
      accion: this.props.accion, //'nuevo'// modificar, nuevo
      disabledSave: true,
    };
    this.valid = { destino: false }; //, direccion: false };
    this.idDestinos = [];
    this.entrega = {
      idEntrega: 0,
      idMovimiento: this.props.idmovimiento,
      idDestino: 1,
      destino: "",
      direccion: "",
      cita: null,
      inicioRuta: null,
      fechaArribo: null,
      fechaSalida: null,
      fechaAlta: null,
      fechaCambio: null,
      latitud: null,
      longitud: null,
      estatus: 0,
    };
  }

  componentDidMount = () => {
    this.idDestinos.push({
      value: 1,
      label: "DESTINO SIN CATALOGO",
      indice: 0,
    });
    if (this.props.destinos) {
      this.props.destinos.map((destino, index) => {
        this.idDestinos.push({
          value: destino.id,
          label: destino.nombre,
          indice: index,
        });
        if (this.entrega) {
          if (this.entrega.idDestino === 1) {
            this.setState({
              idDestino: { value: 1, label: "DESTINO SIN CATALOGO", indice: 0 },
            });
          }
          if (destino.id === this.entrega.idDestino) {
            this.setState({
              idDestino: {
                value: destino.id,
                label: destino.nombre,
                indice: index,
              },
            });
          }
        }
      });
    }

    if (this.state.accion === "nuevo") {
      this.setState({ direccion: "PENDIENTE" });
      this.setState({ destino: "PENDIENTE" });
      this.setState({ latitud: 0 });
      this.setState({ longitud: 0 });
    } else {
      //Se Modifica Registro Actual
      this.entrega = this.props.elementos;
      this.valid = { idDestino: true, destino: true, direccion: true };
      //this.setState({idDestino      : { value: 1, label: "DESTINO SIN CATALOGO", indice:0 } }); //this.props.elementos.idDestino      });
      this.setState({ idEntrega: this.props.elementos.idEntrega });
      this.setState({ destino: this.props.elementos.destino });
      this.setState({ direccion: this.props.elementos.direccion });
      this.setState({ latitud: this.props.elementos.latitud });
      this.setState({ longitud: this.props.elementos.longitud });
      this.setState({ estatus: this.props.elementos.estatus });
      this.setState({
        fechaArribo: this.props.elementos.fechaArribo
          ? new Date(this.props.elementos.fechaArribo)
          : "",
      });
      this.setState({
        cita: this.props.elementos.cita
          ? new Date(this.props.elementos.cita)
          : "",
      });
      this.setState({
        inicioRuta: this.props.elementos.inicioRuta
          ? new Date(this.props.elementos.inicioRuta)
          : "",
      });      
      this.setState({
        fechaSalida: this.props.elementos.fechaSalida
          ? new Date(this.props.elementos.fechaSalida)
          : "",
      });
    }
  };
  isValid = (campo) => {
    switch (campo) {
      //case "idDestino": return this.valid.idDestino;
      //  break;
      case "destino":
        return this.valid.destino;
        break;
      //case "direccion": return this.valid.direccion;
      //  break;
      default:
        break;
    }
  };
  disableSave = () => {
    if (this.state.idDestino.value === 1) {
      if (this.state.destino.lenght > 3) {
        return true;
      } else {
        return false;
      }
    } else {
    }
  };

  delete() {
    this.props.getfuntion(
      "delete",
      "",
      this.props.elementos.idEntrega,
      "entregas_navieras",
      "entregas"
    );
  }
  crud_put() {
    let tmp,
      tmp2 = "";
    tmp = this.entrega.destino;
    tmp2 = this.entrega.direccion;
    this.entrega.destino = tmp.trim();
    this.entrega.direccion = tmp2.trim();
    this.props.getfuntion(
      "put",
      this.entrega,
      "",
      "entregas_navieras",
      "entregas"
    );
  }
  crud_post() {
    this.props.getfuntion(
      "post",
      this.entrega,
      "",
      "entregas_navieras",
      "entregas"
    );
  }
  guardarEntregaNaviera = () => {
    if (this.state.accion === "modificar") this.crud_put();
    else this.crud_post();
    this.props.cerrarModal();
  };
  changeidDestinos = (event) => {
    if (this.props.destinos) {
      this.entrega.idDestino = this.props.destinos[event.indice].id;
      this.entrega.destino = this.props.destinos[event.indice].nombre;
      this.entrega.latitud = this.props.destinos[event.indice].latitud;
      this.entrega.longitud = this.props.destinos[event.indice].longitud;
      this.entrega.direccion = this.props.destinos[event.indice].direccion;
      this.setState({ idDestino: event });
      this.setState({ destino: this.props.destinos[event.indice].nombre });
      this.setState({ direccion: this.props.destinos[event.indice].direccion });
      this.setState({ latitud: this.props.destinos[event.indice].latitud });
      this.setState({ longitud: this.props.destinos[event.indice].longitud });
    }
    if (event.value === 1) {
    } else {
    }
  };

  changeDestino = (event) => {
    this.entrega.destino = event.target.value;
    this.setState({ destino: event.target.value });
    if (event.target.value.length > 5) {
      this.valid.destino = true;
    } else {
      this.valid.destino = false;
    }
  };
  changeDireccion = (event) => {
    this.entrega.direccion = event.target.value;
    this.setState({ direccion: event.target.value });
  };
  changeLatitud = (event) => {
    this.entrega.latitud = event.target.value;
    this.setState({ latitud: event.target.value });
  };
  changeLongitud = (event) => {
    this.entrega.longitud = event.target.value;
    this.setState({ longitud: event.target.value });
  };
  changeEstatus = (event) => {
    this.state.estatus === 0
      ? this.setState({ estatus: 1 })
      : this.setState({ estatus: 0 });
    this.state.estatus === 0
      ? (this.entrega.estatus = 1)
      : (this.entrega.estatus = 0);
  };  
  onChangeCita = (date) => {
    this.entrega.cita = date
      ? timeToDateFill(new Date(date).getTime())
      : null;
    this.setState({ cita: date });
    campo =
      (campo.length ? campo + ", " : campo) +
      " cita: " +
      timeToDateFill(new Date(date).getTime());
  };
  onChangeInicioRuta = (date) => {
    this.entrega.inicioRuta = date
      ? timeToDateFill(new Date(date).getTime())
      : null;
    this.setState({ inicioRuta: date });
    campo =
      (campo.length ? campo + ", " : campo) +
      " inicioRuta: " +
      timeToDateFill(new Date(date).getTime());
  };
  onChangeFechaArribo = (date) => {
    this.entrega.fechaArribo = date
      ? timeToDateFill(new Date(date).getTime())
      : null;
    this.setState({ fechaArribo: date });
    campo =
      (campo.length ? campo + ", " : campo) +
      " fechaArribo: " +
      timeToDateFill(new Date(date).getTime());
  };
  onChangeFechaSalida = (date) => {
    this.entrega.fechaSalida = date
      ? timeToDateFill(new Date(date).getTime())
      : null;
    this.setState({ fechaSalida: date });
    campo =
      (campo.length ? campo + ", " : campo) +
      " fechaSalida: " +
      timeToDateFill(new Date(date).getTime());
  };

  render() {
    return (
      <div>
        {
          //this.props.destinos?
          <div>
            {console.log(this.entrega)}
            {this.state.accion === "modificar" ? (
              <h1> {this.props.elementos.destino} </h1>
            ) : null}
            <Grid.Row>
              <Grid.Col md={12} xl={12}>
                <Grid.Row>
                  <Grid.Col md={8} lg={8}>
                    <Form.Group label="Catalogo">
                      <Select
                        value={this.state.idDestino}
                        onChange={this.changeidDestinos}
                        options={this.idDestinos}
                        valid={
                          this.isValid("idDestino") &&
                          this.state.destino.length > 0
                        }
                        invalid={
                          !this.isValid("idDestino") &&
                          this.state.idDestino.length > 0
                        }
                      />
                    </Form.Group>
                  </Grid.Col>
                  {this.state.idDestino.value === 1 ? (
                    <Grid.Col md={8} lg={8}>
                      <Form.Group label="Nombre de la Entrega">
                        <Form.Input
                          type="text"
                          name="destino"
                          feedback="Al menos 6"
                          value={this.state.destino}
                          placeholder="Ingresa Nombre del Destino..."
                          invalid={
                            !this.isValid("destino") &&
                            this.state.destino.length > 0
                          }
                          onChange={this.changeDestino}
                        />
                      </Form.Group>
                    </Grid.Col>
                  ) : (
                    ""
                  )}
                  {this.state.idDestino.value === 1 ? (
                    <Grid.Col md={8} lg={8}>
                      <Form.Group label="Dirección">
                        <Form.Input
                          type="text"
                          name="direccion"
                          value={this.state.direccion}
                          placeholder="Ingresa Dirección..."
                          onChange={this.changeDireccion}
                        />
                      </Form.Group>
                    </Grid.Col>
                  ) : (
                    ""
                  )}
                  <Grid.Col md={6} lg={6}>
                    <Form.Group label="Latitud">
                      <Form.Input
                        type="number"
                        name="latitud"
                        value={this.state.latitud}
                        placeholder="Ingresa Latitud..."
                        onChange={this.changeLatitud}
                      />
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col md={6} lg={6}>
                    <Form.Group label="Longitud">
                      <Form.Input
                        type="number"
                        name="longitud"
                        value={this.state.longitud}
                        placeholder="Ingresa Longitud.."
                        onChange={this.changeLongitud}
                      />
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col md={4} lg={4}>
                    <Form.Group label="Cita">
                      <DateTimePicker
                        format="y-MM-dd h:mm:ss a"
                        value={this.state.cita}
                        onChange={this.onChangeCita}
                      />{" "}
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col md={4} lg={4}>
                    <Form.Group label="Inicio Ruta">
                      <DateTimePicker
                        format="y-MM-dd h:mm:ss a"
                        value={this.state.inicioRuta}
                        onChange={this.onChangeInicioRuta}
                      />{" "}
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col md={4} lg={4}>
                    <Form.Group label="Fecha Arribo">
                      <DateTimePicker
                        format="y-MM-dd h:mm:ss a"
                        value={this.state.fechaArribo}
                        onChange={this.onChangeFechaArribo}
                      />{" "}
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col md={4} lg={4}>
                    <Form.Group label="Fecha Salida">
                      <DateTimePicker
                        format="y-MM-dd h:mm:ss a"
                        value={this.state.fechaSalida}
                        onChange={this.onChangeFechaSalida}
                      />{" "}
                    </Form.Group>
                  </Grid.Col>
                </Grid.Row>
              </Grid.Col>
            </Grid.Row>
            <div className="float-right">
              <span class="badge">
                <Button
                  size="sm"
                  RootComponent="a"
                  color="primary"
                  //disabled= { this.state.idDestino==='1'? false : true }
                  disabled={this.disableSave()}
                  onClick={this.guardarEntregaNaviera}
                >
                  <span class="badge">
                    <Icon link={true} name="save" />
                    Guardar
                  </span>
                </Button>
              </span>
              {/* {console.log("canceladaManual: " + this.props.elementos.canceladaManual)} */}
              {this.state.accion === "modificar" && this.props.elementos.canceladaManual === false ? (
                <span className="ml-2">
                  <Button
                    pill
                    size="sm"
                    outline
                    color="primary"
                    onClick={() => this.delete()}
                  >
                    <Icon name="trash" />
                  </Button>
                </span>
              ) : null}
            </div>

            <Grid.Col md={3} lg={3}>
              <Form.Group label="Est@tus">
                <Form.Switch
                  type="Checkbox"
                  name="toggle"
                  value={this.state.estatus}
                  checked={this.state.estatus}
                  onChange={this.changeEstatus}
                />
              </Form.Group>
            </Grid.Col>
          </div>
          //  :null
        }
      </div>
    );
  }
}
export default EntregasNavierasForm;
